<template>
  <div>
    <div class="auto-wrap">
      <!-- 카운트 뷰 -->
      <w-trigger-node-count-view :tab-active="active" @change-active-tab="changeActiveTab" />
      <!-- 템플릿 성공/실패 차트 영역 -->
      <div class="title-bar title-h4 bold">템플릿 성공/실패</div>
      <w-trigger-exec-result-chart-view class="mr-b30" :tab-active="active" @change-active-tab="changeActiveTab" />
      <!-- 수행된 템플릿, 실패 템플릿, 실패 작업 TopN 영역 -->
      <el-row type="flex" :gutter="10" class="mr-b30" style="height: 200px;">
        <el-col :span="8">
          <div class="title-bar title-h4 bold">수행된 템플릿 Top 5</div>
          <w-trigger-job-column-chart :tab-active="active" type="execTrg" @change-active-tab="changeActiveTab" />
        </el-col>
        <el-col :span="8">
          <div class="title-bar title-h4 bold">실패 템플릿 Top 5</div>
          <w-trigger-job-column-chart :tab-active="active" type="failTrg" @change-active-tab="changeActiveTab" />
        </el-col>
        <el-col :span="8">
          <div class="title-bar title-h4 bold">실패 작업 Top 5</div>
          <w-trigger-job-column-chart :tab-active="active" type="failJob" @change-active-tab="changeActiveTab" />
        </el-col>
      </el-row>
    </div>
    <!-- Timelne -->
    <div style="width:305px; float:left; margin-left: 10px; padding-left: 20px; border-left: 1px solid #ddd;">
      <w-trigger-timeline :tab-active="active" @change-active-tab="changeActiveTab"></w-trigger-timeline>
    </div>
  </div>
</template>

<script>
import WTriggerTimeline from './components/TriggerTimeline';
import WTriggerNodeCountView from './components/TriggerNodeCountView';
import WTriggerExecResultChartView from './components/TriggerExecResultChartView';
import WTriggerJobColumnChart from './components/TriggerJobColumnChart';

export default {
  name: 'WExecutionSummary',
  components: {
    WTriggerTimeline,
    WTriggerNodeCountView,
    WTriggerExecResultChartView,
    WTriggerJobColumnChart,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    /**
     * 요약 화면에서 다른 탭으로 이동
     * @author jeee12
     * @param  {[type]} tabName [description]
     * @return {[type]}         [description]
     */
    changeActiveTab(tabName, subTabName, filters) {
      this.$emit('change-active-tab', tabName, subTabName, filters);
    },
  },
};
</script>

<style>
.auto-wrap {
    width: calc(100% - 325px);
    margin-left: 0px;
    float: left;
}
</style>



// WEBPACK FOOTER //
// src/views/work/popup/components/ExecutionSummary/index.vue